import ScrollMagic from 'scrollmagic';
import 'ScrollMagicAddIndicators';

export default {

	init() {

		function PriceListScrollMagic( container ) {
			
			var content = container.querySelector('.priceList__content');

			var controller = new ScrollMagic.Controller();

			new ScrollMagic.Scene({triggerElement: content, triggerHook: 0.95 })
				// trigger animation by adding a css class
				.setClassToggle(content, "backToPosition")
				// .addIndicators({name: "- priceList "}) // add indicators (requires plugin)
				.addTo(controller)
				.offset(1);

		}

		var container = document.querySelectorAll('.priceList');

		if( container.length > 0 ) {

			container.forEach( function( box, index ){

				PriceListScrollMagic(box);

			});

		}

	},
	finalize() {



	}

}